module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cp_gaseosas_lata_220_ccso.e9c7f7b6.png";